<template>
  <CFooter :fixed="false">
    <div>
      <span class="ml-1">© 2019 – <a href="https://www.bendingspoons.com">Bending Spoons</a></span>
    </div>
  </CFooter>
</template>

<script>
export default {
  name: 'TheFooter'
}
</script>
